<template>
    <div @click="clk" id="download-btn" :class="{ mg: mg }">
        <svg style="width: 20px;
    height: 20px;" data-v-1616d4b4="" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="icon">
            <path data-v-1616d4b4="" d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline data-v-1616d4b4="" points="7 10 12 15 17 10"></polyline>
            <line data-v-1616d4b4="" x1="12" y1="15" x2="12" y2="3"></line>
        </svg> {{ value }}
    </div>
</template>
<script>

export default {
    props: ['value', 'mg'],
    methods: {
        clk() {
            if (this.$route.name !== 'download') {
                window.location.href = '/download/';
            } else {
                //    下载
                this.$emit('click-btn');
            }
        }
    },
    computed: {

    }
}
</script>
<style lang="scss" scoped>
.mg {
    margin: 30px auto;
}

#download-btn {
    white-space: nowrap;
    padding: 0 30px;
    font-size: 20px;
    text-align: center;
    border-radius: 20px;
    color: white;
    height: 40px;
    line-height: 40px;
    background: #51947f;
    cursor: pointer;
    transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;

    &:hover {
        background: #25d366;
        box-shadow: 0 4px 14px rgba(37, 211, 102, 0.45);
    }

    &:active {
        background: #1ebe57;
        transform: scale(0.98);
    }
}
</style>